import { FormControl } from '@angular/forms';
import { MarketingPreferencesFormField } from './marketing-preferences-form-field.enum';

export interface MarketingPreferencesForm {
  [MarketingPreferencesFormField.MarketingPreferenceEmail]: FormControl<
    boolean | null
  >;
  [MarketingPreferencesFormField.MarketingPreferencePost]: FormControl<
    boolean | null
  >;
  [MarketingPreferencesFormField.MarketingPreferenceTelephone]: FormControl<
    boolean | null
  >;
}
